import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const QUESTIONS = [
  {
    q: "Which browsers does voice dictation work in?",
    a: "TherapyNote uses the Web Speech API, which is fully supported in Google Chrome and Microsoft Edge. If you open the app in another browser, you'll see a friendly warning and can switch over without losing your work.",
  },
  {
    q: "Do I need to train the AI on my voice or my style?",
    a: "No. Claude Sonnet 4.5 already understands natural clinical language and the cues physios use — 'Objective…', 'Assessment…', 'Goals…', 'History…'. You speak normally, the AI maps it to the right fields.",
  },
  {
    q: "Does it understand physio-specific terminology?",
    a: "Yes. Range of motion, MMT grades, end-feel, dermatomes, special tests, and standard orthopaedic terminology are all recognised. Anything it doesn't catch is still preserved in the raw transcript for review.",
  },
  {
    q: "Is my patient data private?",
    a: "All saved data is encrypted in transit and at rest. List views only show patient initials and IDs — never full names. Audio is processed locally in the browser; only the text transcript is sent for extraction.",
  },
  {
    q: "What happens when my free trial ends?",
    a: "You can still log in and view all your previous notes. To create or save new plans you'll need to pick a paid plan. We'll show you a clear upgrade prompt — no surprise lockouts.",
  },
  {
    q: "Is there a mobile app?",
    a: "TherapyNote is web-only by design. Voice dictation works best on a laptop or tablet running Chrome or Edge, right next to your main EMR.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="bg-white py-20 md:py-32 border-t border-slate-100"
      data-testid="faq-section"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <span className="font-figtree text-xs uppercase tracking-[0.22em] font-semibold text-[#059669]">
            FAQ
          </span>
          <h2 className="mt-3 font-outfit text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0F172A] leading-[1.1]">
            The short answers.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10">
          {QUESTIONS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-slate-200 last:border-b-0"
            >
              <AccordionTrigger className="font-outfit text-base md:text-lg font-medium text-[#0F172A] hover:no-underline py-5 text-left">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="font-figtree text-sm md:text-base text-[#475569] leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
